module.exports = __webpack_public_path__ + "media/seq3.mov.e3989676.mp4";